export const vendorFormFields = [
    // Entity Category and LOB Type
    {
        name: "entityCategory",
        label: "Entity Category",
        type: "select",
        placeholder: "Select entity category",
        required: true,
        section: "entityInfo",
        options: [
            { value: "", label: "Select entity category" },
            { value: "client", label: "Client" },
            { value: "vendor", label: "Vendor" },
        ],
    },
    {
        name: "entityLOBType",
        label: "Entity LOB Type",
        type: "select",
        placeholder: "Select entity LOB type",
        required: true,
        section: "entityInfo",
        options: [
            { value: "", label: "Select entity LOB type" },
            { value: "travel", label: "Travel" },
            { value: "mobile", label: "Mobile" },
            { value: "auto", label: "Auto" },
        ],
    },
    {
        name: "selectedlobtypenationality",
        label: "Selected LOB Type Nationality",
        type: "select",
        placeholder: "Select selected LOB type nationality",
        required: false,
        section: "entityInfo",
        conditionalOn: "entityLOBType",
        conditionalValue: "travel",
        options: [
            { value: "", label: "Select selected LOB type nationality" },
            { value: "national", label: "National" },
            { value: "international", label: "International" },
        ],
    },

    // Entity Information Section
    {
        name: 'sectionEntityInfo',
        type: 'section',
        label: 'Entity Information'
    },
    {
        name: 'entityName',
        label: 'Entity Name',
        type: 'text',
        placeholder: 'Enter entity name',
        required: true,
        section: 'entityInfo'
    },
    {
        name: 'address',
        label: 'Address',
        type: 'textarea',
        placeholder: 'Enter address',
        required: true,
        rows: 3,
        section: 'entityInfo'
    },
    {
        name: 'aaDepartmentFunction',
        label: 'AA - Department Function',
        type: 'select',
        placeholder: 'Select department function',
        required: true,
        section: 'entityInfo',
        options: [
            { value: '', label: 'Select department function' },
            { value: 'finance', label: 'Finance' },
            { value: 'operations', label: 'Operations' },
            { value: 'hr', label: 'Human Resources' },
            { value: 'it', label: 'Information Technology' },
            { value: 'sales', label: 'Sales' },
            { value: 'marketing', label: 'Marketing' }
        ]
    },
    {
        name: 'natureOfBusiness',
        label: 'Nature of Business',
        type: 'text',
        placeholder: 'Enter nature of business',
        required: true,
        section: 'entityInfo'
    },
    {
        name: 'entityType',
        label: 'Entity Type',
        type: 'select',
        placeholder: 'Select entity type',
        required: true,
        section: 'entityInfo',
        options: [
            { value: '', label: 'Select entity type' },
            { value: 'proprietorship', label: 'Proprietorship' },
            { value: 'partnership', label: 'Partnership' },
            { value: 'llp', label: 'Limited Liability Partnership (LLP)' },
            { value: 'private_limited', label: 'Private Limited Company' },
            { value: 'public_limited', label: 'Public Limited Company' },
            { value: 'trust', label: 'Trust' },
            { value: 'society', label: 'Society' }
        ]
    },
    {
        name: 'panNumber',
        label: 'PAN Number',
        type: 'text',
        placeholder: 'Enter PAN number',
        required: true,
        section: 'entityInfo',
        validation: (value) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value) || 'Invalid PAN format (e.g., ABCDE1234F)'
    },

    // GST Information
    {
        name: 'sectionGST',
        type: 'section',
        label: 'GST Information'
    },
    {
        name: 'isGSTRegistered',
        label: 'Whether GST Registered?',
        type: 'select',
        placeholder: 'Select option',
        required: true,
        section: 'gst',
        options: [
            { value: '', label: 'Select option' },
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
        ]
    },
    {
        name: 'gstNumberPrimary',
        label: 'GST Number - Primary (used for Billing)',
        type: 'text',
        placeholder: 'Enter primary GST number',
        required: false,
        section: 'gst',
        conditionalOn: 'isGSTRegistered',
        conditionalValue: 'yes',
        validation: (value) => !value || /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value) || 'Invalid GST format'
    },
    {
        name: 'gstNumbersOther',
        label: 'Other GST Numbers',
        type: 'textarea',
        placeholder: 'Enter other GST numbers (one per line)',
        required: false,
        section: 'gst',
        conditionalOn: 'isGSTRegistered',
        conditionalValue: 'yes',
        rows: 3
    },

    // MSME Information
    {
        name: 'sectionMSME',
        type: 'section',
        label: 'MSME Information'
    },
    {
        name: 'isMSMERegistered',
        label: 'Whether registered under MSME?',
        type: 'select',
        placeholder: 'Select option',
        required: true,
        section: 'msme',
        options: [
            { value: '', label: 'Select option' },
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
        ]
    },

    // Contact Person Details
    {
        name: 'sectionContactPerson',
        type: 'section',
        label: 'Contact Person Details'
    },
    {
        name: 'contactPersonName',
        label: 'Contact Person',
        type: 'text',
        placeholder: 'Enter contact person name',
        required: true,
        section: 'contactPerson'
    },
    {
        name: 'contactPersonDesignation',
        label: 'Designation',
        type: 'text',
        placeholder: 'Enter designation',
        required: true,
        section: 'contactPerson'
    },
    {
        name: 'contactPersonMobile',
        label: 'Mobile Number',
        type: 'tel',
        placeholder: 'Enter mobile number',
        required: true,
        section: 'contactPerson',
        validation: (value) => /^\d{10}$/.test(value) || 'Mobile number must be 10 digits'
    },
    {
        name: 'contactPersonEmail',
        label: 'E-mail address',
        type: 'email',
        placeholder: 'Enter email address',
        required: true,
        section: 'contactPerson',
        validation: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || 'Invalid email format'
    },

    // Bank Details
    {
        name: 'sectionBankDetails',
        type: 'section',
        label: 'Bank Details'
    },
    {
        name: 'hasBankDetails',
        label: 'Provide Bank Details?',
        type: 'select',
        placeholder: 'Select option',
        required: true,
        section: 'bankDetails',
        options: [
            { value: '', label: 'Select option' },
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
        ]
    },
    {
        name: 'bankName',
        label: 'Bank Name',
        type: 'text',
        placeholder: 'Enter bank name',
        required: false,
        section: 'bankDetails',
        conditionalOn: 'hasBankDetails',
        conditionalValue: 'yes'
    },
    {
        name: 'accountNumber',
        label: 'Account Number',
        type: 'text',
        placeholder: 'Enter account number',
        required: false,
        section: 'bankDetails',
        conditionalOn: 'hasBankDetails',
        conditionalValue: 'yes'
    },
    {
        name: 'ifscCode',
        label: 'IFSC Code',
        type: 'text',
        placeholder: 'Enter IFSC code',
        required: false,
        section: 'bankDetails',
        conditionalOn: 'hasBankDetails',
        conditionalValue: 'yes',
        validation: (value) => !value || /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value) || 'Invalid IFSC code format'
    },
    {
        name: 'accountType',
        label: 'Account Type',
        type: 'select',
        placeholder: 'Select account type',
        required: false,
        section: 'bankDetails',
        conditionalOn: 'hasBankDetails',
        conditionalValue: 'yes',
        options: [
            { value: '', label: 'Select account type' },
            { value: 'savings', label: 'Savings' },
            { value: 'current', label: 'Current' }
        ]
    },
    {
        name: 'branchName',
        label: 'Branch Name',
        type: 'text',
        placeholder: 'Enter branch name',
        required: false,
        section: 'bankDetails',
        conditionalOn: 'hasBankDetails',
        conditionalValue: 'yes'
    }
];

export const initialVendorState = {
    // Entity Category and LOB
    entityCategory: "",
    entityLOBType: "",
    selectedlobtypenationality: "",

    // Entity Information
    entityName: '',
    address: '',
    aaDepartmentFunction: '',
    natureOfBusiness: '',
    entityType: '',
    panNumber: '',

    // GST Information
    isGSTRegistered: '',
    gstNumberPrimary: '',
    gstNumbersOther: '',

    // MSME Information
    isMSMERegistered: '',

    // Contact Person
    contactPersonName: '',
    contactPersonDesignation: '',
    contactPersonMobile: '',
    contactPersonEmail: '',

    // Bank Details
    hasBankDetails: '',
    bankName: '',
    accountNumber: '',
    ifscCode: '',
    accountType: '',
    branchName: ''
};

// Add email receipt checkbox at the end
vendorFormFields.push(
    {
        name: 'sectionEmailReceipt',
        type: 'section',
        label: 'Email Notification'
    },
    {
        name: 'sendEmailReceipt',
        label: 'Send an email receipt for this response',
        type: 'checkbox',
        required: false,
        section: 'emailReceipt',
        helpText: 'You will receive a confirmation email with the submitted details'
    }
);

// Add to initial state
initialVendorState.sendEmailReceipt = false;
